import { Container, Content, Header, Title, Icon, Body } from './styled';
import { IoIosClose } from 'react-icons/io';



export function Modal(props) {

    const {
        children,
        title,
        isOpen,
        close,
        classNameContent,
        classNameBody,
        zIndex
    } = props;
    
    return (
        <Container 
            isOpen={isOpen} 
            zIndex={zIndex}
            onClick={(e) => {
                if (e.target === e.currentTarget && close) {
                    close();
                }
            }}
        >
            <Content className={(classNameContent) ? classNameContent : ' '}>
                <Header>
                    <Title>{title}</Title>
                    <Icon><IoIosClose onClick={() => close()} /></Icon>
                </Header>
                <Body
                    classNameBody={`${(classNameBody) ? classNameBody : ' '} boM`}
                >
                    {children}
                </Body>
            </Content>
        </Container>
    );
}